//#region recipes/conversation_view/emoji_row/emoji_row_constants.js
var e = [
	"emojiUnicodeOrShortname",
	"isSelected",
	"names",
	"num"
], t = { REACTIONS_ATTRIBUTES: e };
//#endregion
export { e as REACTIONS_ATTRIBUTES, t as default };

//# sourceMappingURL=emoji-row-constants.js.map